import {useAppSelector} from "../hooks";
import {selectCalendarData, selectCurrentEmployee, selectDepartment} from "../../features/AppStateSlice";
import {useMemo} from "react";
import {RREventType} from "../types/RREventType";
import {dateToString} from "../tools";

const useEventsForADay = (date: Date) => {
    const currentEmployee = useAppSelector(selectCurrentEmployee);
    const activeDerpartment = useAppSelector(selectDepartment);
    const isAdmin = currentEmployee?.isAdmin || currentEmployee?.isSuperAdmin;
    let isSupervisor = false;

    const allCalendarEvents = useAppSelector(selectCalendarData);
    const calendarEventsForTheDay = allCalendarEvents.find(event => event.date === dateToString(date));
    const events = useMemo(() => {
        if (!calendarEventsForTheDay) {
            return [];
        }
        const items = calendarEventsForTheDay.items.filter(
            item => item.department === activeDerpartment && (isAdmin || item.employeeId === currentEmployee?.id)
        );

        if (!isSupervisor) {
            isSupervisor = items.find(item => item.employeeId === currentEmployee?.id && item.isSupervisor) !== undefined;
        }

        const events: RREventType[] = [];
        if(isAdmin || isSupervisor) {
            events.push(...calendarEventsForTheDay.events);
        } else {
            items.forEach(item => {
                const event = calendarEventsForTheDay.events.find(event => event.id === item.eventId);
                if (event && events.find(e => e.id === event.id) === undefined) {
                    events.push(event);
                }
            });
        }
        return events;
    }, [calendarEventsForTheDay]);

    return events;
}

export default useEventsForADay;
